import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {BehaviorSubject, Observable, Subject} from "rxjs";

@Injectable({
  providedIn: "root"
})
export class EtherpadEditorService {

  commendationRecommendationCaptionsEmptyValue = {
    commendationsCaption: '',
    recommendationsCaption: ''
  };

  private onSendWindowEventSource = new Subject<any>();
  onSendWindowEvent = this.onSendWindowEventSource.asObservable();

  private contentIsEtherpadSource = new BehaviorSubject<boolean>(false);
  contentIsEtherpad = this.contentIsEtherpadSource.asObservable();

  private commendationRecommendationCaptionsSource: BehaviorSubject<any>
    = new BehaviorSubject<any>({...this.commendationRecommendationCaptionsEmptyValue});
  commendationRecommendationCaptions: Observable<any> = this.commendationRecommendationCaptionsSource.asObservable();

  constructor(private http: HttpClient) {
  }

  sendWindowEvent(data: any) {
    this.onSendWindowEventSource.next(data);
  }

  sendContentIsEtherpad(data: boolean) {
    this.contentIsEtherpadSource.next(true);
  }

  setCaptions(commendationsCaption: string, recommendationsCaption: string){
    this.commendationRecommendationCaptionsSource.next({
      commendationsCaption: commendationsCaption,
      recommendationsCaption: recommendationsCaption
    })
  }

  setPadText(padID: string, text: string) {

    const url = 'http://localhost:3000/setEtherpad';

    const body = {
      padID: padID,
      text: text
    };

    this.http.post(url, body).subscribe(res => {
      console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> I feel lucky')
      console.log(res);
    });
  }

  reset() {
    this.contentIsEtherpadSource.next(false);
    // Should check if is needed to be reset in another place ?
    // this.commendationRecommendationCaptionsSource.next({...this.commendationRecommendationCaptionsEmptyValue});
  }
}
